/**
 * versionChecker.js
 * Consulta /version.json cada 5 minutos y dispara 'forceShowUpdate'
 * si detecta una version diferente a la actual del frontend.
 *
 * Uso en App.vue:
 *   import { startVersionChecker, stopVersionChecker } from '@/utils/versionChecker'
 *   // en mounted():  startVersionChecker(process.env.VUE_APP_VERSION)
 *   // en beforeDestroy(): stopVersionChecker()
 */

const CHECK_INTERVAL_MS = 5 * 60 * 1000 // 5 minutos

let _currentVersion = null
let _intervalId = null

export function startVersionChecker (currentVersion) {
	if (_intervalId) return // ya iniciado
	_currentVersion = currentVersion

	const check = async () => {
		try {
			const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
			if (!res.ok) return
			const data = await res.json()
			if (data.version && data.version !== _currentVersion) {
				console.log(`[VersionChecker] Nueva version: ${data.version} (actual: ${_currentVersion})`)
				document.dispatchEvent(new CustomEvent('forceShowUpdate'))
			}
		} catch (_) {
			// Silencioso en offline o errores de red
		}
	}

	_intervalId = setInterval(check, CHECK_INTERVAL_MS)
}

export function stopVersionChecker () {
	if (_intervalId) {
		clearInterval(_intervalId)
		_intervalId = null
	}
}
